'use strict'

//Import scss for compiling
import './../scss/components.scss'

jQuery(document).ready(function ($) {
    //Set theme mode
    // toggleDarkMode()
})